<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-07 16:19:53
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:59:03
 * @name: 批量导入
 * @Description: 批量导入
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\dialog\push-multiple.vue
 * @Author: desktop
-->
<template>
  <el-dialog title="导入琴行信息" :visible.sync="show" @close="close">
    <div class="container" v-if="show">
      <template v-if="!uploaded">
        <el-upload
          ref="upload"
          class="upload-demo"
          drag
          :auto-upload="false"
          :action="actionAddress"
          :limit="1"
          :on-change="read"
          name="myFile"
          accept=".xlsx,.xls"
          :headers="myHeader"
          :on-success="handleSuccess"
        >
          <i class="el-icon-upload" />
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <div class="downLoad" v-if="downLoadUrl">
          <font>点击</font>
          <font @click="downLoad">下载导入模板</font>
        </div>
        <el-button type="success" size="small" @click="submitUpload"
          >上传到服务器</el-button
        >
      </template>
      <template v-else>
        <div class="result-list">
          <div
            class="result-item error-item"
            v-for="item of error"
            :key="item.A"
          >
            <div class="agency_name">{{ item.A }}</div>
            <div class="content">{{ item.error }}</div>
          </div>
          <div
            class="result-item success-item"
            v-for="item of success"
            :key="item.A"
          >
            <div class="agency_name">{{ item.A }}</div>
            <div class="content">导入成功</div>
          </div>
        </div>
        <div class="error-file" v-if="error_file">
          导入错误的信息生成excel文件,点击<em @click="downLoadError()"
            >下载excel文件</em
          >
        </div>
        <div class="btn-group">
          <el-button type="primary" size="mini" @click="show = false"
            >确定</el-button
          >
        </div>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import cookie from "@/storage/cookie"; //cookie对象
import { tempUrl } from "@/api/pianoCompanyManage/pianoCompanyManage.api";
import { debounceation } from "@/utils/decorator";
export default {
  data() {
    return {
      show: false, //弹窗显隐
      downLoadUrl: "", //下载地址
      actionAddress:
        process.env.VUE_APP_BASE_API + "/admin/agency/importAgency.html", //上传接口
      file: {}, //文件
      filename: "", //文件名
      myHeader: "", //http header
      uploaded: false,
      success: [],
      error: [],
      error_file: "",
    };
  },
  created() {
    const token = new cookie().getToken();
    this.myHeader = {
      Authorization: token,
    };
    this.getDownLoadUrl();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取模板下载地址
     */
    getDownLoadUrl() {
      tempUrl().then((res) => {
        this.downLoadUrl = res.data;
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击下载导入模板
     */
    @debounceation(300)
    downLoad() {
      window.open(`${this.downLoadUrl}`, "_blank");
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     */
    open() {
      this.show = true;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 读取文件
     * @param {Object} file 文件
     */
    read(file) {
      this.file = file.raw;
      this.filename = file.name;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 上传后
     * @param {Object} res 回传信息
     */
    handleSuccess(res) {
      if (res.code !== 200) {
        this.$message.error(res.msg);
        this.show = false;
      } else {
        this.$emit("uploadSuccess");
        this.uploaded = true;
        this.success = res.data.success;
        this.error = res.data.error;
        this.error_file = res.data.error_file;
      }
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭回调
     */
    close() {
      this.uploaded = false;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击上传到服务器
     */
    @debounceation(300)
    submitUpload() {
      this.$nextTick(() => {
        this.$refs.upload.submit();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 下载错误文件
     */
    @debounceation(300)
    downLoadError() {
      window.open(process.env.VUE_APP_BASE_API + this.error_file, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  @extend .extend-flex-column-center;
  .downLoad {
    margin: 15px 0;
    font {
      font-size: $Vars-font-miniTitle-size;
      &:nth-child(2) {
        color: $Vars-normal-color;
        @extend .extend-clickElement;
      }
    }
  }
  .result-list {
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    @extend .extend-flex-column-normal;
    .result-item {
      width: 100%;
      &:not(:first-child) {
        margin-top: 10px;
      }
      padding: 10px 5px;
      box-sizing: border-box;
      @extend .extend-flex-normal;
      &.success-item {
        &::before {
          flex-shrink: 0;
          content: "";
          width: 4px;
          height: 4px;
          border-radius: 4px;
          background: $Vars-success-color;
          margin-top: 6px;
          margin-right: 8px;
        }
      }
      &.error-item {
        &::before {
          flex-shrink: 0;
          content: "";
          width: 4px;
          height: 4px;
          border-radius: 4px;
          background: $Vars-danger-color;
          margin-top: 6px;
          margin-right: 8px;
        }
        background: $Vars-background-light-gray;
        .content {
          color: $Vars-danger-color !important;
        }
      }
      .agency_name {
        font-size: $Vars-font-miniContent-size;
        margin-right: 16px;
      }
      .content {
        font-size: $Vars-font-secondary-size;
      }
    }
  }
  .error-file {
    width: 100%;
    margin: 30px 0 10px;
    font-size: $Vars-font-content-size;
    em {
      color: $Vars-normal-color;
      @extend .extend-clickElement;
    }
  }
  .btn-group {
    margin-top: 20px;
  }
}
</style>